import { createMemo, For, Show } from 'solid-js';
import ItemStackView from './ItemStackView';
import SellbotOfferPicker from './SellbotOfferPicker';
import { useVillagerOfferText } from './VillagerOfferPicker';
import { useTranslation } from '../hooks/useTranslation';
import { fromItemStackDto } from '../services/itemRefAdapters';
import type { SellbotOfferDto } from '../api/generated/schemas';
import chipStyles from './PlayerListAttachPicker.module.css';

// Chip row in PlayerListAttachPicker's style, with SellbotOfferPicker as the add control so offers
// are searched and rendered the same way as everywhere else.
export default function SellbotOfferMultiPicker(props: {
    offers: SellbotOfferDto[];
    value: readonly string[];
    excludedOfferIds?: readonly string[];
    onChange: (offerIds: string[]) => void;
    placeholder: string;
    disabled?: boolean;
}) {
    const { t } = useTranslation();
    const text = useVillagerOfferText();

    const chosenOffers = createMemo(() => props.value
        .map(offerId => props.offers.find(offer => offer.id === offerId))
        .filter((offer): offer is SellbotOfferDto => offer !== undefined));

    const addableOffers = createMemo(() => props.offers.filter(offer =>
        !props.value.includes(offer.id) && !(props.excludedOfferIds ?? []).includes(offer.id)));

    return (
        <div class={chipStyles.picker}>
            <Show when={chosenOffers().length > 0}>
                <div class={chipStyles.chips}>
                    <For each={chosenOffers()}>
                        {(offer) => (
                            <div class={chipStyles.chip}>
                                <ItemStackView stack={fromItemStackDto(offer.item)} size={18} />
                                <span class={chipStyles.chipName}>{text.itemLabel(offer.item)}</span>
                                <button type="button" class={chipStyles.chipRemove} disabled={props.disabled}
                                    title={t('REMOVE')} onClick={() => props.onChange(props.value.filter(id => id !== offer.id))}>
                                    <i class="fa-solid fa-xmark" />
                                </button>
                            </div>
                        )}
                    </For>
                </div>
            </Show>

            <SellbotOfferPicker
                offers={addableOffers()}
                value=""
                onChange={(offerId) => props.onChange([...props.value, offerId])}
                placeholder={props.placeholder}
                disabled={props.disabled} />
        </div>
    );
}
